import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Globe } from '@phosphor-icons/react';

interface LanguageSelectorProps {
  value?: string;
  onValueChange?: (value: string) => void;
}

export function LanguageSelector({ value, onValueChange }: LanguageSelectorProps) {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
  ];

  const selectedLanguage = value || i18n.language;
  const currentLanguage = languages.find(lang => lang.code === selectedLanguage) || languages[0];

  const handleChange = (newValue: string) => {
    if (onValueChange) {
      onValueChange(newValue);
    } else {
      i18n.changeLanguage(newValue);
    }
  };

  return (
    <Select value={selectedLanguage} onValueChange={handleChange}>
      <SelectTrigger className="w-[140px] border-none shadow-none gap-2" aria-label="Select language">
        <Globe className="w-4 h-4" />
        <SelectValue>
          <span className="flex items-center gap-1">
            <span>{currentLanguage.flag}</span>
            <span className="hidden sm:inline">{currentLanguage.name}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {languages.map((language) => (
          <SelectItem key={language.code} value={language.code}>
            <span className="flex items-center gap-2">
              <span>{language.flag}</span>
              <span>{language.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
